import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as FVERIFY from './shapeverify.res.js'

function getMclassName(inData) {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    return inData['workers'][mclassindex]
}

function setFactorCtrl(curChart, inData, chartName, region) {
    
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_FACTORS,
        rectMain: curRect

    }
    FVERIFY.setFactorsTitle('因子集(' + inData['mfactors'].datas.length + ')')
    FVERIFY.clearFactors()
    for (let index = 0; index < inData['mfactors'].datas.length; index++) {
        FVERIFY.incrFactors(CLAPI.getData(inData['mfactors'], 'showname', index))
    }
    const mclassname = getMclassName(inData)
    
    let factoridx = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factoridx', 0), inData['mfactors'].datas.length)
    curCfg.config.selectIndex = factoridx

    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            if (result.selectIndex < 0) {
                return factoridx
            }
            else if (result.selectIndex !== factoridx ) {
                Init.setUserInfo(inData.modulename, mclassname + 'factoridx', result.selectIndex)
                factoridx = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factoridx', 0), inData['mfactors'].datas.length)
                onLoadData(inData, true)
            }
        }
    })
}
function setMclassCtrl(curChart, inData, chartName, region) {
    
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    curCfg.config.selectIndex = mclassindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            console.log(chartName, result)
           
            if (result.selectIndex < 0) {
                return factoridx
            }
            else if (result.selectIndex !== mclassindex ) {
                Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
                mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
                onClassLoad(inData)
            }
        }
    })
}
function setYearCtrl(curChart, inData, chartName, region) {
    
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_YEAR,
        rectMain: curRect

    }
    const mclassname = getMclassName(inData)

    let yearindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'yearindex', 0), inData['years'].length)
    
    curCfg.config.selectIndex = yearindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'yearindex', result.selectIndex)
            onLoadData(inData, true)
        }
    })
}

function setShapeChart(curChart, inData, chartName, region) {

    const mclassname = getMclassName(inData)

    const factoridx = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factoridx', 0), inData['mfactors'].datas.length)

    const fstyle = CLAPI.getData(inData['mfactors'], 'fstyle', factoridx)

    const chart = curChart.getChart(chartName)
    
    const cvname = chartName + '.chart'
    const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)    
    const curCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 5
            }, 
        },
        config: CLAPI.Utils.mergeObjectOfDeep(
            {
                header : {
                    spaceY: 4, // Y方向留空     
                },
                autoexpand : true,
                fieldlock  : 2,  // 按左键时，前面3个字段不动    
                // fieldmins  : 3,       
                curKeyIdx  : 0,  // 用于检索curKey的字段索引
            }, CLAPI.ChartRes.CHART_TABLE),
        tableInfo : CLAPI.Utils.copyObjectOfDeep(FVERIFY.shapeInfo),
        rectMain: curRect
    }
    const curchart = chart.createChart(cvname, 'system.table', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // if (result.event === 'headclick') {
        //     console.log(result);
        // }
        if (result.event === 'click') {
            // changeLink(curChart, inData, result.curCode, chartName)
        }
        if (result.event === 'changeselect') {
            // changeLink(curChart, inData, result.curCode, chartName)
        }
    })
    chart.bindData(curchart, cvname)
}

function readyShapeChart(curChart, inData, chartName) {
    const mclassname = getMclassName(inData)
    const factoridx = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factoridx', 0), inData['mfactors'].datas.length)

    const fstyle = CLAPI.getData(inData['mfactors'], 'fstyle', factoridx)
    const findex = CLAPI.getData(inData['mfactors'], 'index', factoridx)
    
    const chart = curChart.getChart(chartName)  
    
    const cvname = chartName + '.chart'
    
    const curdata = FVERIFY.GetShapeTable(inData['verify'], inData['factors'], findex, fstyle)
    console.log(curdata);
                
    chart.setData(cvname, curdata)
    
}
function drawFVerify(inData, isFirst) {

    console.log('Draw ====> FVerify Line')
    // console.log(JSON.stringify(inData));
    console.log(inData);
    
    const curChart = Init.getSysChart()

    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['shapeChart', 'mclassCtrl', 'yearCtrl', 'factorCtrl'])

        const canvas = Init.canvas

        const chead = 25 * Init.scale
        const cleft = FVERIFY.FWIDTH * Init.scale
        // 设置顶部窗口
        setMclassCtrl(curChart, inData, 'mclassCtrl', {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: chead,
        })
        // 设置分区窗口
        setYearCtrl(curChart, inData, 'yearCtrl', {
            style: 'sidebar',
            top: chead,
            left: 0,
            width: canvas.width,
            height: chead,
        })
        
        const whigh = canvas.height - chead - chead
        // 设置左部窗口
        setFactorCtrl(curChart, inData, 'factorCtrl', {
            style: 'sidebar',
            top: chead + chead,
            left: 0,
            width: cleft - Init.scale,
            height: whigh,
        })
        
        const leftw = (canvas.width - cleft)
        // 设置第一个窗口
        setShapeChart(curChart, inData, 'shapeChart', {
            style: 'average',
            top: chead + chead,
            left: cleft,
            width: leftw,
            height: whigh,
        })
    }
    
    readyShapeChart(curChart, inData, 'shapeChart')

    curChart.onPaint()
}

function onLoadData(inData, isFirst) {
    const mclassname = getMclassName(inData)
    
    let yearindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'yearindex', 0), inData['years'].length)
    
    function getVerify() {

        let factoridx = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factoridx', 0), inData['mfactors'].datas.length)

        const fname = CLAPI.getData(inData['mfactors'], 'fname', factoridx)
        let fstyle = ''
        if (factoridx > 0) {
            fstyle = CLAPI.getData(inData['mfactors'], 'fstyle', factoridx)
        }

        Init.sendCommand({
            cmds: {
                "verify": {
                    "cmd": "get",
                    "subject": fname + fstyle + '.db_verify',
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['years'][yearindex],
                    "info": {
                        "offset": 0,
                    }
                },
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['verify'] = datas['verify']
                drawFVerify(inData, isFirst)
            }
        });
    }
    Init.sendCommand({
        cmds: {
            "factors": {
                    "cmd": "get",
                    "subject": "CN000000.db_fcname",
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['years'][yearindex],
                    "info": {
                        "offset": 0,
                    }
                },
        }
    },
    function reply(datas) {
        if (Init.checkDatas(datas)) {
            inData['factors'] = datas['factors']
            // inData['ofactors'] = FVERIFY.getoneFactors(datas['factors'])
            inData['mfactors'] = FVERIFY.getmulFactors(datas['factors'])
            console.log(inData);
            getVerify(inData, isFirst)
        }
    });
}

export function onClassLoad(inData) {

    const mclassname = getMclassName(inData)
    let years = [] 
    Init.sendCommand({
            cmds: {
                "years": {
                    "cmd": "files",
                    "service": inData.modulepath + '/' + mclassname + "/verify/*.mdb"
                }
            }
        },
        function reply(datas) {
            console.log(mclassname, datas)
            if (Init.checkDatas(datas)) {
                // 这里更新分钟数据
                datas['years'].datas.sort((a,b) => b[1].localeCompare(a[1]))
                for (let index = 0; index < datas['years'].datas.length; index++) {
                    let fname = datas['years'].datas[index][1];
                    years.unshift(fname.split('.').slice(0, -1).join('.'));
                }
                FVERIFY.onInit(inData['workers'], years)
                // console.log(years)
                inData['years'] = years
                onLoadData(inData, true)
            }
            else {
                const mclassindex = Init.getUserInfo(inData.modulename, 'mclassindex', -1)
                Init.setUserInfo(inData.modulename, 'mclassindex', mclassindex + 1)
                console.log(mclassindex);                
            }
        });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'shapeverify'
    inData.modulepath = argvs.modulepath ?? 'shape'

    inData['workers'] = ['kbar', 'klike']
    
    onClassLoad(inData)
}
// 注册方法到参数表